import { restClient } from '@/Core'

import { LETTER_TEMPLATE_REST_URL } from '../Contracts/ILetter'

import type { LetterCollectionResponse, LetterTemplateOption } from '../Contracts/ILetter'
import type { LetterProviderValue } from '@/Ship/Contracts/LetterProvider'

/** Шаблонів одного провайдера одиниці; з великим запасом — одним запитом. */
const TEMPLATES_LIMIT = 100

/**
 * Провайдери з прив'язкою шаблону до конкретних власників (R-06): для них
 * набір — загальні плюс прив'язані до цього власника (`applicableTo`, §6.2).
 * Для контактів і документів — усі шаблони провайдера.
 */
const BOUND_PROVIDERS = new Set<LetterProviderValue>(['client', 'carrier'])

/**
 * Шаблони листа для кнопки «Відправити лист» (`SPEC-013` §6.2):
 * `GET /services/letter_templates` з провайдером і псевдофільтром
 * `applicableTo` = uuid власника. Видалені бек не віддає (R-15).
 */
export const LoadLetterTemplatesTask = async (
    provider: LetterProviderValue,
    ownerUuid: string | null
): Promise<LetterTemplateOption[]> => {
    const conditions: unknown[] = [{ field: 'provider', op: '=', value: provider }]

    if (ownerUuid !== null && BOUND_PROVIDERS.has(provider)) {
        conditions.push({ field: 'applicableTo', op: '=', value: ownerUuid })
    }

    const raw = await restClient.get(
        `${LETTER_TEMPLATE_REST_URL}?limit=${TEMPLATES_LIMIT}&filters=${encodeURIComponent(JSON.stringify({ and: conditions }))}`,
        undefined,
        { forceRefresh: true }
    )
    const data = raw as unknown as LetterCollectionResponse<LetterTemplateOption> | LetterTemplateOption[] | null
    const list = Array.isArray(data) ? data : (data?.items ?? data?.['hydra:member'] ?? [])

    return Array.isArray(list)
        ? list.filter((item) => typeof item?.uuid === 'string' && typeof item?.title === 'string')
        : []
}
